<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" loader="dots"></loading>

    <div class="chart-page">
      <div class="card mb-2">
        <div class="card-body">
          <div class="chart-title mb-4">階段占比報表</div>
          <div class="form-row">
            <div
              v-for="(chart, index) in phaseData"
              :key="chart.index"
              class="col-sm-12 col-md-4"
            >
              <div class="form-group">
                <apexchart
                  width="400"
                  type="donut"
                  class="chart"
                  :options="phaseChart"
                  :series="chart"
                />
                <p v-if="phaseData" style="text-align: center">
                  {{ rows[index].Month | month }}月份
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card mb-2">
        <div class="card-body">
          <div class="form-row">
            <div class="col-sm-12 col-md-6">
              <div class="chart-title mb-2">黑名單報表</div>
              <apexchart
                width="100%"
                height="450"
                type="bar"
                :options="blacklistChart"
                :series="blacklistSeries"
              />
            </div>
            <div class="col-sm-12 col-md-6">
              <div class="chart-title mb-2">登入紀錄報表</div>
              <apexchart
                type="bar"
                width="100%"
                height="450"
                :options="loginRecordChart"
                :series="loginRecordData"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import moment from "moment";
import { config } from "@/components/back/table_config.js";

export default {
  name: "SituationRoom",

  data() {
    return {
      // 月份
      month: [],

      // 每個階段占比
      phaseChart: {
        // 圖表
        labels: ["新增履歷", "已邀約", "已面談", "已完成面談評估", "面談未到"],
      },
      phaseData: [], // data

      // 黑名單
      blacklistChart: {
        // 圖表
        xaxis: {
          categories: [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月",
          ],
        },
        yaxis: {
          min: 0,
          max: 100,
          tickAmount: 10,
        },
      },
      blacklistData: [], // data

      // 登入紀錄
      loginRecordChart: { // 圖表
        xaxis: {
          categories: [],
        },
        yaxis: {},
      },
      loginRecordData: [ // data
        {
          name: "數量",
          data: [],
        },
      ],

      // table
      rows: [],
      columns: [
        {
          label: "月份",
          name: "Month",
          slot: "Month",
        },
        {
          label: "新增履歷",
          name: "NewResumeQuantity",
        },
        {
          label: "已邀約",
          name: "InvitationQuantity",
        },
        {
          label: "已面談",
          name: "InterviewQuantity",
        },
        {
          label: "已完成面談評估",
          name: "InterviewCompletedQuantity",
        },
        {
          label: "面談未到",
          name: "NotArrivedQuantity",
        },
      ],
      config,
    };
  },

  methods: {
    getAllChart() {
      this.getRecruitProgress();
      this.getBlacklistChart();
    },

    // 各階段占比 API
    getRecruitProgress() {
      const vm = this;
      const api = `${window.endpoints.api}/Report/RecruitProgress/Chart`;
      const params = {
        startMonth: moment(vm.monthRange[0]).format("YYYY-MM-DD"),
        endMonth: moment(vm.monthRange[1]).format("YYYY-MM-DD"),
      };

      vm.$store.dispatch("updateLoading", true);
      vm.$http
        .get(api, { params })
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);
            vm.rows = response.data;
            vm.phaseData = response.data.map((item) => {
              return [
                item.NewResumeQuantity,
                item.InvitationQuantity,
                item.InterviewQuantity,
                item.InterviewCompletedQuantity,
                item.NotArrivedQuantity,
              ];
            });
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 黑名單圖表 API
    getBlacklistChart() {
      const vm = this;
      const api = `${window.endpoints.api}/Report/Blacklist/Chart`;

      const params = {
        startMonth: moment(vm.monthRange[0]).format("YYYY-01"),
        endMonth: moment(vm.monthRange[1]).format("YYYY-12"),
      };

      vm.$store.dispatch("updateLoading", true);
      vm.$http
        .get(api, { params })
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);
            let arr = [];
            response.data.forEach((item) => {
              arr.push(item.Quantity);
            });
            if (response.data.length < 12) {
              const shortage = 12 - response.data.length;
              let i = 0;
              while (i < shortage) {
                arr.push(0);
                i += 1;
              }
            }
            vm.blacklistData = arr;
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 登入紀錄圖表 API
    getLoginRecordChart() {
      const vm = this;
      const api = `${window.endpoints.api}/Report/UserLoginRecord/Chart`;

      const params = {
        topRanking: 10,
        StartDate: vm.dateRange[0],
        EndDate: vm.dateRange[1],
      };

      vm.$store.dispatch("updateLoading", true);
      vm.$http
        .get(api, { params })
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);
            this.loginRecordChart = {
              xaxis: {
                categories: response.data.categories,
              },
              yaxis: {
                max: response.data.max,
                min: response.data.min,
                tickAmount: response.data.tickAmount,
              },
            };
            this.loginRecordData = [
              {
                name: "登入紀錄",
                data: response.data.data,
              },
            ];
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  computed: {
    // 黑名單
    blacklistSeries: function () {
      return [
        {
          name: "黑名單數量",
          data: this.blacklistData,
        },
      ];
    },

    // 登入紀錄
    loginRecordSeries: function () {
      return [
        {
          name: "登入紀錄",
          data: this.loginRecordData,
        },
      ];
    },

    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  filters: {
    month: function (date) {
      return moment(date).format("MM");
    },
  },

  created() {
    const last_two_month = moment().subtract(2, "months").format("YYYY-MM"); // 兩個月前
    const this_month = moment().format("YYYY-MM"); // 這個月
    this.monthRange = [new Date(last_two_month), new Date(this_month)];

    const thirtyDaysAgo = moment().subtract(30, "days").format("YYYY-MM-DD"); // 三十天前
    this.dateRange = [thirtyDaysAgo, this.$common.getToday()];

    this.getRecruitProgress();
    this.getBlacklistChart();
    this.getLoginRecordChart();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
.chart-title {
  text-align: center;
}

.test {
  display: flex;
  align-items: center;
  justify-content: center;

  .chart {
    flex: 1;
  }
}
</style>
